import { isEmpty } from 'lib';
import { magicNumbers } from './magicNumbers';

export const ignoreRequestParams = (params) => {
  if (params['source'] === 'both') {
    delete params['source'];
  }
  if (params['query'] === magicNumbers.MEGA_SUBJECT_QUERY_ID) {
    delete params['query'];
    delete params['q'];
  } else if (
    !isEmpty(params['q']) &&
    params['query'] === magicNumbers.YOUR_SEARCH_QUERY_ID
  ) {
    delete params['query'];
  } else {
    delete params['q'];
  }
  return params;
};
